import React from 'react';

export default function SuspendedScreen({ message }) {
  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.iconWrap}>
          <span style={{ fontSize: '40px' }}>🚫</span>
        </div>
        <h1 style={S.title}>Account Suspended</h1>
        <p style={S.message}>
          {message || 'Your company account has been suspended. Please contact Tracern support to resolve this.'}
        </p>
        <div style={S.divider} />
        <p style={S.support}>
          Need help? Contact{' '}
          <strong style={{ color: 'var(--color-primary)' }}>Tracern Support</strong>
        </p>
        <button
          onClick={() => { localStorage.clear(); window.location.href = '/login'; }}
          style={S.btn}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: 'var(--color-bg)', padding: '24px',
  },
  card: {
    background: 'var(--color-surface)', borderRadius: '20px', padding: '40px 32px',
    width: '100%', maxWidth: '420px', textAlign: 'center',
    border: '1px solid var(--color-border)',
    boxShadow: 'var(--shadow-lg)',
  },
  iconWrap: {
    width: '72px', height: '72px', borderRadius: '20px',
    background: '#FFF5F5', display: 'flex', alignItems: 'center',
    justifyContent: 'center', margin: '0 auto 20px',
    border: '1px solid #FEB2B2',
  },
  title:   { fontSize: '22px', fontWeight: 700, color: 'var(--color-danger)', marginBottom: '12px' },
  message: { fontSize: '15px', color: 'var(--color-text-secondary)', lineHeight: 1.7, marginBottom: '24px' },
  divider: { height: '1px', background: 'var(--color-border)', margin: '0 0 20px' },
  support: { fontSize: '14px', color: 'var(--color-text-muted)', marginBottom: '20px' },
  btn: {
    width: '100%', padding: '12px', borderRadius: 'var(--radius-md)',
    background: 'var(--color-primary)', color: '#fff',
    border: 'none', cursor: 'pointer', fontSize: '15px', fontWeight: 500,
  },
};
